<div *ngIf="meeting"
     [ngClass]="{'dashboard-meetings': true, 'has-pre-work': hasPreWork, 'card': showCard}">
    <div class="card-body d-flex flex-row align-items-center">
        <adapt-display-meeting-summary class="w-100 gap-2"
                                       [meeting]="meeting"
                                       [compact]="compact"
                                       [showIcon]="true"
                                       [showTeamName]="showTeamName"
                                       [linkDisabled]="notSelectable"
                                       [selected]="selected"
                                       [preWorkVisible]="preWorkVisible"
                                       [preWorkClickable]="preWorkClickable"
                                       (meetingStarted)="meetingStarted.emit($event)"
                                       (elementSelected)="elementSelected.emit($event)"
                                       [showStatus]="showStatus"
                                       [showStartButton]="showStartButton"></adapt-display-meeting-summary>
    </div>
</div>
